import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';
import { UtilService } from 'src/app/service/util';
import { PedidoCompra, PedidoCompraEnviarEmailFornecedor, PedidoCompraLista } from '../interface/pedido-compra';
import { IFiltroListaPedidoCompra } from '../filter/filtro-lista-pedido-compra';
import { IFiltroListaPedidoCompraPainelAprovacao } from '../../painel-aprovacao-pedido-compra/filter/filtro';
import { PedidoCompraPainelAprovacaoLista } from '../../painel-aprovacao-pedido-compra/interface/interface';
import { DadosFornecedor, FornecedorPedidoCompra } from 'src/app/interface/fornecedor-pedido-compra';


@Injectable({
  providedIn: 'root'
})
export class PedidoCompraService {

  constructor(
    private http: HttpClient,
    private utilService: UtilService
  ) { }

  url = `${environment.urlApiProtheus}/wsrcompedidocompra`;


  postPedidoCompra(dados: PedidoCompra): Observable<PedidoCompra> {

    const httpOptions = this.utilService.filtrosHttpOptions();

    return this.http.post<PedidoCompra>(`${this.url}`,dados, httpOptions);

  }

  getPedidoCompraLista(filtro: IFiltroListaPedidoCompra): Observable<PedidoCompraLista> {

    const httpOptions = this.utilService.filtrosHttpOptions(filtro);

    return this.http.get<PedidoCompraLista>(`${this.url}`, httpOptions);

  }

  getPedidoCompra(CC7NUM: string, filtro: {} = {}): Observable<PedidoCompra> {

    const httpOptions = this.utilService.filtrosHttpOptions(filtro);

    return this.http.get<PedidoCompra>(`${this.url}/${CC7NUM}`, httpOptions);

  }

  deletePedidoCompra(CC7NUM: string): Observable<any> {

    const httpOptions = this.utilService.filtrosHttpOptions();

    return this.http.delete(`${this.url}/${CC7NUM}`, httpOptions);

  }

  postPedidoCompraEnviaEmailFornecedor(dados: PedidoCompraEnviarEmailFornecedor): Observable<any> {

    const httpOptions = this.utilService.filtrosHttpOptions();

    return this.http.post(`${this.url}/envia-email-fornecedor`,dados, httpOptions);

  }

  getPainelAprovacao(filtro: IFiltroListaPedidoCompraPainelAprovacao): Observable<PedidoCompraPainelAprovacaoLista> {

    let httpOptions = this.utilService.filtrosHttpOptions(filtro);

    return this.http.get<PedidoCompraPainelAprovacaoLista>(`${this.url}/painel-aprovacao/`,httpOptions);
  }

  getDadosPedidoCompra(dados: DadosFornecedor): Observable<FornecedorPedidoCompra> {
    const httpOptions = this.utilService.filtrosHttpOptions(dados);
    return this.http.get<FornecedorPedidoCompra>(`${this.url}/dados-pedido-compra`, httpOptions);
  }

}
